export default __webpack_public_path__ + "GT-Alpina-Fine-Standard-Light-Italic.woff2";